import AppDataService from './AppDataService'

const COMMON_BASE = 'patients'

export default class PatientDataService {

    static async getPatientGridList(params) {
        return await AppDataService.get(`${COMMON_BASE}`, params)
    }

    static async createNewPatient(data) {
        return await AppDataService.post(`${COMMON_BASE}`, data)
    }

    static async savePatientPreferences(uuid, data) {
        return await AppDataService.post(`${COMMON_BASE}/${uuid}/preferences`, data)
    }

    static async updatePatientDetails(uuid, data) {
        return await AppDataService.patch(`${COMMON_BASE}/${uuid}`, data)
    }

    static async getPatientDetails(uuid, params) {
        return await AppDataService.get(`${COMMON_BASE}/${uuid}`, { params })
    }

    static async createDiagnosticBundle(data) {
        return await AppDataService.post(`health-info/diagnosis-report`, data);
    }

    static async createDischargeSummaryBundle(data) {
        return await AppDataService.post(`health-info/discharge-summary`, data);
    }

    static async createHealthDocumentBundle(data) {
        return await AppDataService.post(`health-info/health-doc`, data);
    }

    static async createOpConsultationBundle(data) {
        return await AppDataService.post(`health-info/op-consult`, data);
    }

    static async createPrescriptionBundle(data) {
        return await AppDataService.post(`health-info/prescription`, data);
    }

    static async createWellnessBundle(data) {
        return await AppDataService.post(`health-info/wellness`, data);
    }

    static async createImmunizationBundle(data) {
        return await AppDataService.post(`health-info/immunization`, data);
    }

    static async createInvoiceBundle(data) {
        return await AppDataService.post(`health-info/invoice`, data);
    }

    static async pushBundle(data) {
        return await AppDataService.post(`abha/m2/care-context-link`, data);
    }

    static async retryDataPush(data) {
        return await AppDataService.post(`abha/m2/push/data/retry`, data);
    }

    static async saveBundle(data) {
        return await AppDataService.post(`abha/m2/save/bundle`, data);
    }

    static async consentIdRequest(data) {
        return await AppDataService.post(`abha/m3/request/init`, data);
    }

    static async consentRequestStatus(data) {
        return await AppDataService.post(`abha/m3/request/status`, data);
    }

    static async getConsentList(data) {
        const { pageNumber, limit, patientId} = data;
        const queryParams = new URLSearchParams(
        Object.fromEntries(
            Object.entries({ pageNumber, limit, patientId }).filter(
            ([_, value]) => value !== undefined && value !== null
            )
        )
        );
        return await AppDataService.get(`abha/m3/consent-details?${queryParams.toString()}`);
    }

    static async getConsentRecordsList(uuid) {
        return await AppDataService.get(`abha/m3/consent-details/${uuid}`)
    }

    static async getDecryptedData(data) {
        return await AppDataService.post(`ecdh/decrypt`, data)
    }

    static async invitePortalAccess(uuid) {
        return await AppDataService.post(`${COMMON_BASE}/${uuid}/invite`, {})
    }

    static async resendPortalAccess(uuid) {
        return await AppDataService.post(`${COMMON_BASE}/${uuid}/invite/resend`, {})
    }

    static async revokedPortalAccess(uuid) {
        return await AppDataService.post(`${COMMON_BASE}/${uuid}/invite/disable`, {})
    }

    static async upcomingbirthdays() {
        return await AppDataService.get(`${COMMON_BASE}/upcomingbirth`,)
    }

    static async validateAadhaar(data) {
        return await AppDataService.post(`${COMMON_BASE}/validate/aadhar`,data)
    }

    static async getExistingABHADetails(data) {
        const queryString = new URLSearchParams(data).toString();
        return await AppDataService.get(`abha?${queryString}`);
    }

    static async getExistingABHADetailsByMobile(data) {
        return await AppDataService.post(`abha/m1/profile/search`, data);
    }

    static async getCaptcha() {
        return await AppDataService.get(`abha/captcha`);
    }

    static async updateCaptcha(captchaId) {
        return await AppDataService.post(`abha/captcha/${captchaId}`, {});
    }

    static async abhaIntAadhaarValidation(data) {
        return await AppDataService.post(`abha/send/otp`,data)
    }

    static async abhaUpdateValidation(data) {
        return await AppDataService.post(`abha/request/otp`, data)
    }

    static async otpVerification(data) {
        return await AppDataService.post(`abha/verify/otp`,data)
    }

    static async createABHAPatient(data, force) {
        const url = force ? `abha/patient-create?force=true` : `abha/patient-create`;
        return await AppDataService.post(url, data);
    }      

    static async getABHAPatient(data) {
        return await AppDataService.post(`abha/m1/request/otp`, data)
    }

    static async mobileOtpVerify(data) {
        return await AppDataService.post(`abha/m1/verify/otp`, data)
    }

    static async abhaUpdateOtpVerification(data) {
        return await AppDataService.post(`abha/update/details`, data)
    }

    static async abhaAddressSuggetions(data){
        return await AppDataService.post(`abha/suggest/address`,data)
    }

    static async abhaAddressUpdate(data){
        return await AppDataService.post(`abha/change/address`,data)
    }

    static async abhaProfilePictureUpdate(data){
        return await AppDataService.patch(`abha/update/picture`, data)
    }
    
    static async downloadCard(data){
        return await AppDataService.post(`abha/card`,data)
    }
}